const supplierConfig = {
  ddStorage: {
    userId: 'rarmt_supplier_user_id',
    userName: 'rarmt_csupplier_user_name'
  }
};
export default supplierConfig;
